<template>
    <div class="realTimeSelection">
        <div class="main-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <li><a href="javascript:void(0)">酒店预订</a>></li>
                        <li>实时精选</li>
                    </ul>
                </div>
                <div class="realTimeSelection-search">
                    <div class="left">
                        <div class="content-item input">
                            <i class="iconfont icon-search"></i>
                            <input type="text" data-type="searchAll" maxlength="50" placeholder="酒店名称/城市/景点/关键词"
                                   v-model="key" @click="close();searchBtn()" class="searchAll" @input="searchInput()"/>
                            <i class="iconfont icon-guanbi" v-if="key" @click="key='';"></i>
                            <HotCity @select="hotCity" :productType="'4'" :isHotCityShow="isHotCityShow"></HotCity>
                            <SearchAll :keyword="key" :productType="'4'" :isKeyResultShow="isKeyResultShow"
                                       @selectCity="selectCity"
                                       @selectHotel="selectHotel" @selectLandmark="selectLandmark"></SearchAll>
                        </div>
                        <div class="content-item">
                            <i class="iconfont icon-calendar"></i>
                            <div class="item-body-box" @click="calendar.show = true">
                                <div class="room-count">
                                    {{CheckIn}}
                                </div>
                                <DatePicker @select="calendar.select" v-if="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :endDate="calendar.end"></DatePicker>
                            </div>
                        </div>
                        <div class="content-item">
                            <i class="iconfont icon-room"></i>
                            <div class="item-body-box">
                                <div class="room-count" @click="close();isRoomCountShow = true">
                                    {{RoomCount}}
                                </div>
                                <transition name="bounce" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="300">
                                    <RoomCount @select="selectCount" v-show="isRoomCountShow"></RoomCount>
                                </transition>
                            </div>
                        </div>
                        <div class="content-item">
                            <i class="iconfont icon-renshu"></i>
                            <div class="item-body-box">
                                <div class="room-count">
                                    <span @click="close();isRoomPeopelShow = true">{{AdultCount}}成人{{ChildrenCount}}儿童</span>
                                </div>
                                <transition name="bounce" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="300">
                                    <SelectHotelPeople @select="roomPeopelNum"
                                                       v-show="isRoomPeopelShow"></SelectHotelPeople>
                                </transition>
                            </div>
                        </div>
                        <div class="content-item">
                            <i class="iconfont icon-unie641"></i>
                            <div class="item-body-box">
                                <div class="room-count" @click="close();isHotelStarShow = true">
                                    <span class="room-count" v-if="Star === ''">不限</span>
                                    <span class="room-count" v-if="Star === '0,1'">二星及以下</span>
                                    <span class="room-count" v-if="Star === '2'">三星舒适</span>
                                    <span class="room-count" v-if="Star === '3'">四星高档</span>
                                    <span class="room-count" v-if="Star === '5'">五星豪华</span>
                                </div>
                                <transition name="bounce" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="300">
                                    <HotelStar @select="selectStar" v-show="isHotelStarShow"></HotelStar>
                                </transition>
                            </div>
                        </div>

                        <div class="content-item">
                            <i class="iconfont icon-guoji"></i>
                            <div class="item-body-box">
                                <div class="room-count" @click="close();isCountryShow = true">
                                    {{Country.CNName}}
                                </div>
                                <transition name="bounce" enter-active-class="animated bounceInUp"
                                            leave-active-class="animated fadeOutDown"
                                            :duration="300">
                                    <Country @select="selectCountry" v-show="isCountryShow"></Country>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="btn" @click="searchInit()">
                            搜索
                        </div>
                    </div>
                </div>
                <div :class="total<=10?'realTimeSelection-table realTimeSelection-table-margin':'realTimeSelection-table'"
                     id="table-box">
                    <div class="null-box" v-if="isTableFixed"></div>
                    <table id="table-head" :class="isTableFixed?'table-head':''">
                        <thead>
                        <tr>
                            <th width="135px" class="hotel-head-name">酒店名称</th>
                            <th width="125px">房型名称</th>
                            <th>子产品</th>
                            <th width="55px" v-for="(item,index) in dateArr" :class="tdIndex===index?'active':''">
                                {{item|dateShort}}
                                <br>
                                {{item|delUTC|dateWeek}}
                            </th>
                        </tr>
                        </thead>
                        <tbody v-if="isLoading">
                        <tr>
                            <td colspan="18">
                                <div class="textCenter">
                                    <Loading :isLogoLoading="isLogoLoading"></Loading>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table id="table-fixe" class="table">
                        <tbody v-for="(item, index) in list" class="hotel-name-fixed">
                        <tr class="hotel-info" v-for="(room,ri) in item.Rooms.RPs" :class="index===0&&ri===0?'first-tr':''">
                            <td width="135px" class="hotel-name align-left" :rowspan="item.Rooms.RPs.length" v-if="ri==0">
                                <div :class="titleItemActive === index?'fixed-ing':''">
                                    <a href="#" @click="routeToDetails(item)">{{item.HotelName}}</a>
                                    <div class="star">
                                        <i class="iconfont icon-unie641" v-if="item.Star>=0"></i>
                                        <i class="iconfont icon-unie641" v-if="item.Star>=2"></i>
                                        <i class="iconfont icon-unie641" v-if="item.Star>=4"></i>
                                        <i class="iconfont icon-unie641" v-if="item.Star>=6"></i>
                                        <i class="iconfont icon-unie641" v-if="item.Star>=8"></i>
                                        <i class="iconfont icon-unie641" v-if="item.Star>=10"></i>
                                        <i class="iconfont icon-unie641 half" v-if="'13579'.indexOf(item.Star)>-1"></i>
                                    </div>
                                </div>
                            </td>
                            <td width="125px" class="hotel-room first-td align-left" :rowspan="room.C" v-if="item.RoomsRow.indexOf(ri)!==-1">
                           
                                <div>
                                   
                                    {{room.RoomName}}
                                    
                                </div>
                            </td>
                            <td
                                    :class="trIndex===ri&&tbodyIndex===index?'tr-active hotel-rp-name align-left':'hotel-rp-name align-left'"
                                    @mouseover="trIndex=ri;tbodyIndex=index;"
                                    @mouseout="trIndex='';tbodyIndex='';">
                                <div>
                                    {{room.RPName}}
                                </div>
                            </td>
                            <td width="55px"
                                :class="trIndex===ri&&tbodyIndex===index&&tdIndex === i?'active tr-active':trIndex===ri&&tbodyIndex===index?'tr-active':tdIndex === i?'active':''"
                                v-for="(ie,i) in room.Prices"
                                @mouseover="tdIndex=i;tbodyIndex=index;trIndex=ri;"
                                @mouseout="tdIndex='';tbodyIndex='';trIndex='';"
                                @click="checkDate(index,room,ie,i,ri)"
                            >
                                <div v-if="ie.Price&&ie.Stock>0">
                                    {{ie.Price}}
                                    <br>
                                    {{ie.Stock>5?'>5':ie.Stock}}
                                </div>
                                <div v-else>
                                    查
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect"
                              v-if="total>10">
                    </Paginate>
                </div>
            </div>
        </div>
        <div class="modal-box" v-if="isModalShow">
            <div>
                <div class="modal-in" id="modal-in">
                    <h4 v-drag>入离日期选择
                        <i class="iconfont icon-close"
                           @click="tdIndex='';tbodyIndex='';trIndex='';isModalShow = false"></i>
                    </h4>
                    <div class="modal-main">
                        <div class="label">
                            <label>入住日期</label>
                            <div class="input">
                                <input type="text" @click="calendarB.show = true" class="date-time" data-type="time"
                                       v-model="CheckInB">
                                <DatePickerB @select="calendarB.select" v-if="calendarB.show" :start="calendarB.start"
                                             :last="calendarB.last"
                                             :beginDate="calendarB.begin" :endDate="calendarB.end"></DatePickerB>
                            </div>
                        </div>
                        <div class="label">
                            <label>离店日期</label>
                            <div class="input">
                                <input type="text" @click="calendarB.show = true" class="date-time" data-type="time"
                                       v-model="CheckOutB">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" v-drag>
                        <div class="submit" @click="book()">
                            提交
                        </div>
                        <div class="cancel" @click="tdIndex='';tbodyIndex='';trIndex='';isModalShow = false">
                            取消
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="modalOK"></Modal>
    </div>
</template>

<script>
    import Country from './../../common/cmpnt/country/country'
    import HotelStar from './../../common/cmpnt/hotelStar/hotelStar'
    import SearchAll from './../../common/cmpnt/searchAll/SearchAll'//模糊搜索
    import HotCity from './comm/HotCity.vue' //热门城市
    import SelectHotelPeople from './../../common/cmpnt/selecthotelPeople/selecthotelPeople'//选择每间房间的住客数
    import RoomCount from './../../common/cmpnt/roomCount/roomCount.vue' //选择房间数
    import DatePicker from './comm/datePicker.vue'//日期(单选)
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import DatePickerB from './../../common/cmpnt/datePicker/datePicker'//日期(双选)
    import Modal from './../../common/cmpnt/Modal/modal.vue'//跳转提示框
    export default {
        name: "RealTimeSelectionList",
        components: {
            Paginate,
            Country,
            HotelStar,
            SelectHotelPeople,
            RoomCount,
            DatePicker,
            SearchAll,
            HotCity,
            DatePickerB,
            Loading,
            Modal
        },
        data: function () {
            return {
                isModalShow: false,
                isKeyResultShow: false,
                isHotCityShow: false,
                isRoomCountShow: false,
                isHotelStarShow: false,
                isCountryShow: false,
                isRoomPeopelShow: false,
                isLogoLoading: true,
                isLoading: true,
                titleItemActive: '',
                currentHotelInfo: '',
                currentRoomInfo: '',
                currentDailyRates: '',
                key: '香港',
                total: 100,
                list: '',
                roomList: [],
                dateArr: [],
                Page: 1,
                Star: '',
                tdIndex: '',
                trIndex: '',
                tbodyIndex: '',
                PageSize: 10,
                RegionID: '3201',
                From: 1,
                ID: '',
                ProductType: '4',
                HotelIDs: [],
                CheckIn: this.getDate(0),
                CheckInB: this.getDate(0),
                CheckOutB: this.getDate(1),
                RoomCount: 1,
                AdultCount: 2,
                ChildrenCount: 0,
                ChildrenAges: [],
                Country: {
                    "Code2": "CN",
                    "Code3": "CHN",
                    "Num": "156",
                    "Iso": "ISO 3166-2:CN",
                    "ENName": "China",
                    "CNName": "中国大陆"
                },
                isTableFixed: false,
                modal: {
                    show: false,
                    config: {}
                },
                modalType: 'book',
                calendar: {
                    show: false,
                    start: this.getDate(0),
                    begin: this.getDate(0),
                    end: this.dateAdd(this.getDate(0), 14),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            return;
                        }
                        this.calendar.begin = begin;
                        this.calendar.end = this.dateAdd(begin, 14);
                        this.CheckIn = begin;
                        this.calendarB.start = begin;
                        this.calendarB.last = this.dateAdd(begin, 14);
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                },
                calendarB: {
                    show: false,
                    start: this.getDate(0),
                    last: this.dateAdd(this.getDate(0), 14),
                    begin: this.CheckInB,
                    end: this.CheckOutB,
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendarB.show = false;
                            return;
                        }
                        this.calendarB.begin = begin;
                        this.calendarB.end = end;
                        this.CheckInB = begin;
                        this.CheckOutB = end
                        this.$nextTick(function () {
                            this.calendarB.show = false;
                            // this.changeFilter();
                        });
                    }
                },
            }
        },
        directives: {
            drag: {
                // 指令的定义
                bind: function (el) {
                    let odiv = el;
                    odiv.onmousedown = (e) => {
                        let box = document.getElementById('modal-in')
                        let disX = e.clientX - box.offsetLeft;
                        let disY = e.clientY - box.offsetTop;
                        document.onmousemove = (e) => {
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;

                            box.style.marginLeft = 0 + 'px';
                            box.style.marginTop = 0 + 'px';
                            box.style.left = left + 'px';
                            box.style.top = top + 'px';
                        };
                        document.onmouseup = (e) => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                        };
                    };
                }
            }
        },

        created: function () {

        },
        watch: {},
        mounted() {
            this.handleDateArr();
            this.initData();
            var tbox = document.getElementById('table-box');
            tbox.style.minHeight = document.documentElement.clientHeight - 369 + 'px'
            window.addEventListener('scroll', this.handleScroll, false)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, false);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll, false);
        },
        methods: {
            isRoomNameShow(ri,index){
              if(this.list[index].indexOf(ri)!==-1){
                  return true
              }
              return false;
            },
            modalOK() {
                if (this.modalType == 'book') {
                    this.$router.push('/hotelBook');
                } else {
                    this.routeToDetails(this.currentHotelInfo)
                }
            },
            //打开详情
            routeToDetails(item) {
                var obj = {
                    HotelID: item.ID,
                    From: item.From,
                    CheckIn: this.CheckIn,
                    CheckOut: this.dateAdd(this.CheckIn, 1),
                    ProductType: '4',
                    RoomCount: this.RoomCount,
                    AdultCount: this.AdultCount,
                    ChildrenCount: this.ChildrenCount,
                    ChildrenAges: this.ChildrenAges,
                    MyLat: '',
                    MyLon: '',
                    RegionID: this.RegionID,
                    Country: this.Country,
                    MyCityRegionID: '',
                }
                this.dao.set('hotelDetailsParams', obj)
                window.open('#/hotelDetails?lastKey=' + this.key, '_blank');
            },
            book() {
                var that = this;
                for (var i = 0; i < that.DateDiff(that.CheckInB, that.CheckOutB); i++) {
                    for (var j = 0; j < that.currentRoomInfo.Prices.length; j++) {
                        if (that.dateAdd(that.CheckInB, i) === that.dateToYMD(that.currentRoomInfo.Prices[j].PriceDate)) {
                            if (!that.currentRoomInfo.Prices[j].Price || that.currentRoomInfo.Prices[j].Stock === 0 || that.currentRoomInfo.Prices[j].Stock < that.RoomCount) {
                                that.error({
                                    title: '提示',
                                    content: that.currentRoomInfo.Prices[j].Stock < that.RoomCount?that.dateToYMD(that.currentRoomInfo.Prices[j].PriceDate) + '不可预订(需要的房间数超过可预定数。)！！！':that.dateToYMD(that.currentRoomInfo.Prices[j].PriceDate) + '不可预订！！！'
                                })
                                return
                            }
                        }
                    }
                }

                that.modal = {
                    show: true,
                    content: '正在为您核对酒店库存信息，请稍后....',
                }
                var tempwindow=window.open();//这个定义放在请求前面
                var params = {
                    HotelID: that.currentHotelInfo.ID,
                    ProductType: that.ProductType,
                    RoomID:that.currentRoomInfo.RoomID,
                    RPID: that.From == 1 ? that.currentRoomInfo.RPID : '',
                    From: that.From,
                    CheckIn: that.CheckInB,
                    CheckOut: that.CheckOutB,
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenCount: that.ChildrenCount,
                    MyLat: '',
                    MyLon: '',
                    MyCityRegionID: '',
                    Batch: 0,
                    CountryCode: that.Country.Code2,
                }
                that.postRequest({
                    url: that.Api.getPrices,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        for (var i = 0; i < res.Result.length; i++) {
                            if (that.currentRoomInfo.RoomID === res.Result[i].RoomID) {
                                if (res.Result[i].Prices[0].Tip > 1) {
                                    that.modal.show = false;
                                    tempwindow.close();
                                    that.error({title: '提示', content: res.Result[i].Prices[0].Errors});
                                    return;
                                }
                                var obj = {
                                    From: that.From,
                                    RegionID: that.currentHotelInfo.CityID,
                                    HotelName: that.currentHotelInfo.HotelName,
                                    RoomName: that.currentRoomInfo.RoomNameEn == "others" ? res.Result[i].Prices[0].RoomName : that.currentRoomInfo.RoomName,
                                    RPName: res.Result[i].Prices[0].RPName,
                                    CheckIn: that.CheckInB,
                                    CheckOut: that.CheckOutB,
                                    RoomCount: that.RoomCount,
                                    AdultCount: that.AdultCount,
                                    Star: that.currentHotelInfo.Star,
                                    HotelAddress: that.currentHotelInfo.Address,
                                    HotelPhone: that.currentHotelInfo.Phone,
                                    AdultPrice: that.From === 0 ? res.Result[i].Prices[0].Price : res.Result[i].Prices[0].AdultPrice,
                                    days: that.getDays(that.CheckInB, that.CheckOutB),
                                    Token: res.Result[i].Prices[0].Token,
                                    CancelPolicy: res.Result[i].Prices[0].CancelPolicy,
                                    Breakfast: res.Result[i].Prices[0].Breakfast,
                                    Currency: res.Result[i].Prices[0].Currency,
                                    Tip: res.Result[i].Prices[0].Tip,
                                    Stock: res.Result[i].Prices[0].Stock,
                                    MaxPerson: res.Result[i].Prices[0].MaxPerson,
                                    Breakfast: res.Result[i].Prices[0].Breakfast,
                                    DailyRates: res.Result[i].Prices[0].DailyRates,
                                    IsAskRoom: res.Result[i].Prices[0].IsAskRoom,
                                    NeedIDCard: res.Result[i].Prices[0].NeedIDCard,
                                    details: that.currentHotelInfo,
                                    room: that.currentRoomInfo
                                }
                                that.dao.set('bookInfo', obj);

                                that.checkBookAble(res.Result[i].Prices[0].Token, function (res) {
                                    that.modal.show = false;
                                    //价格发生变化，提示变化信息
                                    if (res.Result.Changed) {
                                        var price = res.Result.NewAmount - res.Result.OrgAmount;
                                        var str = (res.Result.NewAmount - res.Result.OrgAmount > 0) ? '上涨' : '下降';
                                        that.modalType = 'book';
                                        that.modal = {
                                            isComfirm: true,
                                            show: true,
                                            content: '该房间的价格已变更，价格' + str + '了' + price + '元！是否继续预订？',
                                        }
                                        tempwindow.close();
                                    } else {
                                        that.isModalShow = false;
                                        that.tdIndex = '';
                                        that.tbodyIndex = '';
                                        that.trIndex = '';
                                        // that.$router.push('/hotelBook');
                                        
                                        tempwindow.location='#/hotelBook';
                                        // window.open('#/hotelBook', '_blank');

                                    }
                                })
                            }
                        }
                    } else {
                        that.modal.show = false;
                        that.error({title: '提示', content: res.Msg || '不能预订'});
                        tempwindow.close();
                    }

                });
            },
            // 检查是否可以预订
            checkBookAble(token, callback) {
                var that = this;
                var param = {
                    token: token
                }
                that.postRequest({
                    url: that.Api.checkBookable,
                    params: param
                }).then(res => {
                    that.modal.show = false;
                    //当IsSuccess==true时，表示有库存可以预订
                    if (res.IsSuccess) {
                        //价格发生变化，提示变化信息
                        callback(res);
                    } else {
                        // 此处要做判断，若价格变更，则跟据价格提示用户进行下一步操作
                        this.error({title: '提示', content: res.Msg || '不能预订'});
                        this.$nextTick(function () {
                            that.modal.show = false;
                            that.$forceUpdate();
                        });
                    }
                });
            },
            dateToYMD (date) {
                if(!date) return '';
                var da = new Date(date);
                var year=da.getFullYear();
                var month =  da.getMonth()+1;
                var day = da.getDate();
                if(month<10){month='0'+month};
                if(day<10){day='0'+day};
                return year+'-'+month+'-'+day;
            },
            //选择下单日期
            checkDate(index, room, data, i, ri) {
               
                var that = this;
                this.currentHotelInfo = this.list[index];
                if (that.From == 0) {
                    that.modalType = 'hotel';
                    that.modal = {
                        isComfirm: true,
                        show: true,
                        content: '海外酒店价格数据仅供参考，是否跳转到酒店详情页预订？',
                    }
                    return
                }
                if (data.Stock === 0 || !data.Price) {
                    return
                }

                that.currentRoomInfo = room;
                that.CheckInB = that.dateToYMD(data.PriceDate);
                that.CheckOutB = that.dateAdd(that.dateToYMD(data.PriceDate), 1);
                that.calendarB.begin = that.dateToYMD(data.PriceDate);
                that.calendarB.end = that.dateAdd(that.dateToYMD(data.PriceDate), 1);
                that.isModalShow = true;
                setTimeout(function () {
                    that.tdIndex = i;
                    that.tbodyIndex = index;
                    that.trIndex = ri;
                }, 50)
            },
            //条件搜索
            searchInit() {
                this.list = '';
                this.Page = 1;
                this.total = 0;
                this.handleDateArr();
                this.initData();
            },
            //选择城市
            selectCity(city) {
                if(city.From===0){
                    this.error({title: '提示', content: '当前只支持中国大陆、中国香港、中国澳门地区搜索！'});
                    return
                }
                this.RegionID = city.ID;
                this.From = city.From;
                this.CityName = city.CName;
                this.key = city.CName || city.SName;
                this.isKeyResultShow = false;

                this.Name = '';
                this.HotelIDs = [];
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择酒店
            selectHotel(hotel) {
                if(hotel.From===0){
                    this.error({title: '提示', content: '当前只支持中国大陆、中国香港、中国澳门地区搜索！'});
                    return
                }
                this.isKeyResultShow = false;
                this.RegionID = hotel.CityID;
                this.key = hotel.Name;
                this.HotelIDs = hotel.HotelID;
                this.From = hotel.From;
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            //选择地标
            selectLandmark(landmark) {
                if(landmark.From===0){
                    this.error({title: '提示', content: '当前只支持中国大陆、中国香港、中国澳门地区搜索！'});
                    return
                }
                this.RegionID = landmark.CityID;
                this.CityName = landmark.City;
                this.LandmarkCode = landmark.ID;
                this.LandmarkName = landmark.Name;
                this.From = landmark.From;
                this.key = landmark.Name;
                this.isKeyResultShow = false;
                this.Name = '';
                this.HotelIDs = [];
            },
            searchBtn() {
                this.isKeyResultShow = false
                this.isHotCityShow = true
            },
            searchInput() {
                this.isKeyResultShow = true
                this.isHotCityShow = false
            },
            hotCity(obj) {
                this.isKeyResultShow = false;
                this.isHotCityShow = false;
                if (!obj) {
                    return
                }
                this.RegionID = obj.I;
                this.From = obj.F;
                this.CityName = obj.N;
                this.key = obj.N;

                this.Name = '';
                this.HotelIDs = '';
                this.LandmarkName = '';
                this.LandmarkCode = '';
            },
            selectCountry(obj) {
                this.close();
                if (!obj) return;
                this.Country = obj;
            },
            selectCount(val) {
                this.close();
                if (!val) return;
                this.RoomCount = val;
            },
            //客人住房数
            roomPeopelNum(Adult, Children, ages) {
                this.isRoomPeopelShow = false;
                if (!Adult && !Children) {
                    return
                }
                if (Adult == 'close') {
                    return;
                }
                this.AdultCount = Adult;
                this.ChildrenAges = ages;
                this.ChildrenCount = Children;
            },
            selectStar(val) {
                this.close();
                if (!val) return;
                if (val == '10') {
                    this.Star = '';
                } else {
                    this.Star = val;
                }
            },
            //数量统计
            getCount(list){
                console.log(list);
                var list=list;
                var length=0;
                list.forEach((item)=>{
                    length++
                })
                console.log(length);
                return length;
            },
            close() {
                this.isRoomCountShow = false;
                this.isHotelStarShow = false;
                this.isCountryShow = false;
            },
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isTableFixed = scrollTop > 207 ? true : false;
                var fixed = document.getElementsByClassName('hotel-name-fixed');
                var rooms = document.getElementsByClassName('hotel-room');

                if (this.isTableFixed) {
                    this.titleItemActive = 0
                    //酒店名跟随
                    for(var i = 0; i<fixed.length; i++){
                        if (fixed[i].offsetTop + 209 <= scrollTop && (fixed[i+1]&&fixed[i+1].offsetTop + 209 > scrollTop)) {
                            this.titleItemActive = i
                        }else if(fixed[fixed.length-1].offsetTop + 209 <= scrollTop){
                            this.titleItemActive = fixed.length-1
                        }
                    }
                    //房型名跟随
                    for(var i = 0; i<rooms.length; i++){
                        rooms[i].classList.remove("room-fixed")
                        if (rooms[i].offsetTop + 209 <= scrollTop && (rooms[i+1]&&rooms[i+1].offsetTop + 209 > scrollTop)) {
                            rooms[i].classList.add("room-fixed")
                        }else if(rooms[rooms.length-1].offsetTop + 209 <= scrollTop){
                            rooms[rooms.length-1].classList.add("room-fixed")
                        }
                    }
                } else {
                    this.titleItemActive = '';
                    for(var i = 0; i<rooms.length; i++){
                        rooms[i].classList.remove("room-fixed")
                    }
                }
            },
            //补全表格数据，不满15天补满
            handleTrDateList(list) {
                if (list.DailyRates.length == 15) {
                    return list
                } else {
                    var a = [];
                    var l = list;
                    for (var j = 0; j < l.DailyRates.length; j++) {
                        a.push(l.DailyRates[j].DateStr)
                    }
                    for (var i = 0; i < this.dateArr.length; i++) {
                        if (a.indexOf(this.dateArr[i]) === -1) {
                            var j = {
                                DateStr: this.dateArr[i]
                            }
                            l.DailyRates.push(j)
                        }
                    }
                    l.DailyRates.sort(function (a, b) {
                        return b['DateStr'] < a['DateStr'] ? 1 : -1
                    })
                    return l
                }
            },
            handleDateArr() {
                this.dateArr = [];
                for (var i = 0; i < 15; i++) {
                    var date = new Date(this.CheckIn);
                    date.setDate(date.getDate() + i);//获取count天后的日期
                    var year = date.getFullYear();
                    var month = date.getMonth() + 1;
                    var day = date.getDate();
                    if (month >= 1 && month <= 9) {
                        month = "0" + month;
                    }
                    if (day >= 0 && day <= 9) {
                        day = "0" + day;
                    }
                    var time = year + '-' + month + '-' + day;
                    this.dateArr.push(time);
                }
            },
            DateDiff(sDate1, sDate2) {    //sDate1和sDate2是xxxx-xx-xx格式  
                var aDate, oDate1, oDate2, iDays
                aDate = sDate1.split("-")
                oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])    //转换为xx-xx-xxxx格式  
                aDate = sDate2.split("-")
                oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
                iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)    //把相差的毫秒数转换为天数  
                return iDays
            },
            dateAdd(startDate, addDateNum) {     //计算多少天后的日期
                startDate = new Date(startDate);
                startDate = +startDate + 1000 * 60 * 60 * 24 * addDateNum;
                startDate = new Date(startDate);
                var m = (startDate.getMonth() + 1) < 10 ? '0' + (startDate.getMonth() + 1) : startDate.getMonth() + 1;
                var d = startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate();
                var nextStartDate = startDate.getFullYear() + "-" + m + "-" + d;
                return nextStartDate;
            },
            //获取酒店数据
            initData() {
                var that = this;
                that.isLoading = true;
                var params = {
                    RegionID: that.RegionID,
                    From: that.From,
                    ProductType: that.ProductType,
                    Name: '',
                    Landmark: '',
                    LandmarkCode: '',
                    StarsStr: that.Star == 5 ? '4,5' : that.Star,
                    PriceMin: '',
                    PriceMax: '',
                    CheckIn: that.CheckIn,
                    CheckOut: that.dateAdd(that.CheckIn, 15),
                    RoomCount: that.RoomCount,
                    AdultCount: that.AdultCount,
                    ChildrenCount: that.ChildrenCount,
                    ChildrenAges: that.ChildrenAges,
                    Page: that.Page,
                    PageSize: that.PageSize,
                    HotelIDs: that.HotelIDs,
                    Sort: 0,
                    MyLat: '',
                    MyLon: '',
                    Radius: '',
                    MyCityRegionID: '',
                }

                that.postRequest({
                    url: that.Api.price,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess && res.Result.length > 0) {
                        that.total = res.Total;
                        that.list = res.Result;
                        var arr = [];
                        that.list.forEach(v => {
                            arr.push(v.ID);
                            v.Room = [];
                            v.Rooms = [];
                            v.RoomsRow = [];
                            v.RoomInfo = [];
                        })
                        that.getDailyPrices(arr)
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                        // that.getRoomList(res.Result)
                    } else {
                        that.list = '';
                        that.total = 0;
                        this.error({title: '提示', content: res.Msg || '获取酒店失败！'});
                    }
                });
            },
            refrain(arr) {
                var tmp = [];
                if(Array.isArray(arr)) {
                    arr.concat().sort().sort(function(a,b) {
                        if(a==b && tmp.indexOf(a) === -1) tmp.push(a);
                    });
                }
                return tmp;
            },
            getDailyPrices(hotels) {
                var that = this;
                var param = {
                    Start: this.CheckIn,
                    DayCount:15,
                    HotelIDs:hotels,
                }
                that.postRequest({
                    url: that.Api.getDailyPrices,
                    params: param
                }).then(res => {
                    if (res && res.IsSuccess && res.Result.length > 0) {
                        that.roomList = res.Result;
                        for(var i = 0;i<that.roomList.length;i++){
                            if(that.roomList[i].RPs.length>0){
                                var ki = [0];
                                var id = that.roomList[i].RPs[0].RoomID;
                                for(var k = 1; k<that.roomList[i].RPs.length;k++){
                                    if(id !==that.roomList[i].RPs[k].RoomID){
                                        id = that.roomList[i].RPs[k].RoomID
                                        ki.push(k)
                                    }
                                }
                                that.refrain(ki)
                            }
                            for(var j = 0;j<that.list.length;j++){
                                if(that.roomList[i].HotelID === that.list[j].ID){
                                    that.list[j].Rooms = that.roomList[i];
                                    that.list[j].RoomsRow = ki
                                    that.$forceUpdate();
                                }
                            }
                        }
                        that.isLoading = false;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    } else {
                        that.isLoading = false;
                        that.total = 0;
                        this.error({title: '提示', content: res.Msg || '获取酒店房型失败！'});
                    }
                });
            },
            //获取房型数据
            getRoomList(list) {
                var that = this;
                for (var i = 0; i < list.length; i++) {
                    (function () {
                        var params = {
                            HotelID: list[i].ID,
                            ProductType: that.ProductType,
                            From: that.From,
                            CheckIn: that.CheckIn,
                            CheckOut: that.dateAdd(that.CheckIn, 15),
                            RoomCount: that.RoomCount,
                            AdultCount: that.AdultCount,
                            ChildrenCount: that.ChildrenCount,
                            MyLat: '',
                            MyLon: '',
                            MyCityRegionID: '',
                            Batch: 0,
                            CountryCode: that.Country.Code2,
                        }
                        that.postRequest({
                            url: that.Api.getPrices,
                            params: params
                        }).then(res => {
                            if (res && res.IsSuccess) {
                                that.roomList = res.Result;
                                for (var j = 0; j < that.roomList.length; j++) {
                                    for (var k = 0; k < that.list.length; k++) {
                                        if (that.list[k].ID == that.roomList[j].HotelID) {
                                            that.list[k].RoomInfo = that.roomList[j]
                                            if (that.From == 1) {
                                                for (var l = 0; l < that.roomList[j].Prices.length; l++) {
                                                    that.list[k].Room.push(that.handleTrDateList(that.roomList[j].Prices[l]))
                                                    that.$forceUpdate();
                                                }
                                            } else {
                                                that.list[k].Room.push(that.handleTrDateList(that.roomList[j]))
                                                that.$forceUpdate();
                                            }
                                        }
                                    }
                                }
                                that.$nextTick(() => {
                                    if(localStorage.getItem('lang')=='t'){
                                        that.$zh_tran(localStorage.getItem('lang'))
                                    }    
                                })
                            } else {
                                this.error({title: '提示', content: res.Msg || '获取酒店房型失败！'});
                            }
                        });
                    })(i)
                }
                that.isLoading = false;
            },
            // 选择页数
            pageSelect(val) {
                this.total = 0;
                this.list = [];
                this.Page = val;
                this.initData();
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/realTimeSelection/List.vue